import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/lessonContent';
export function PainPoints() {
  return <section className="py-24 px-4 bg-black" data-id="element-163" data-mp="2lmsqcmz6p8ku">
      <div className="max-w-3xl mx-auto" data-id="element-164" data-mp="26ypif81kzmte">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-165" data-mp="26xmu97vn7yh6">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-166" data-mp="1xxrculbhv78p">Ça te parle ?</h2>
          <p className="text-lg text-gray-300 leading-relaxed bg-dark-card p-6 rounded-2xl border border-dark-border text-left" data-id="element-167" data-mp="1y044jq720vyy">
            Dimanche soir. 22h. Ton cours d&apos;espagnol est demain matin. Et tu es encore là — à chercher des activités, à
            essayer de construire une leçon qui fonctionne vraiment, qui soit fluide, qui soit professionnelle et intentionnelle
            plutôt que quelque chose que tu as bricolé en vingt minutes.
            <br data-id="element-168" data-mp="3nbcz4gul6qrv" />
            <br data-id="element-169" data-mp="3nbwhtzs29j6y" />
            <span className="text-gold-light font-medium" data-id="element-170" data-mp="3nalaxr3bjvbm">Pas parce que tu ne sais pas l&apos;espagnol.</span> Pas parce que tu
            n&apos;es pas un bon professeur. Mais parce que personne ne t&apos;a jamais donné un système complet et prêt à
            enseigner. Tu construis chaque cours de zéro. Le temps que tu devrais passer à te reposer — tu le passes à planifier.
            Et le pire, ce n&apos;est pas l&apos;épuisement. Le pire, c&apos;est d&apos;entrer en classe en sachant que tu aurais
            pu être mieux préparé.
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-171" data-mp="1b4aq9rs1n3vi">
          <h3 className="text-xl font-bold text-white mb-8 text-center" data-id="element-172" data-mp="1k3e7srbkbb7w">Le vrai coût de ne pas avoir le bon outil :</h3>
          <ul className="space-y-4" data-id="element-173" data-mp="30h4mes0b5hvs">
            {painPoints.map((point, index) => <motion.li key={point} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08
          }} className="flex items-start gap-4 bg-dark-card p-4 rounded-xl border border-red-900/30" data-id="element-174" data-mp="2vitcyidxd9e3" data-mpi={index}>
                <span className="text-red-500 mt-1" aria-hidden="true" data-id="element-175" data-mp="223qnfn7mtipc">
                  🔴
                </span>
                <span className="text-gray-300" data-id="element-176" data-mp="1aenmagb1kogx">{point}</span>
              </motion.li>)}
          </ul>
          <div className="text-center mt-12 pt-8 border-t border-dark-border" data-id="element-177" data-mp="1efzbikq077ol">
            <p className="text-2xl font-serif font-bold text-gold-gradient" data-id="element-178" data-mp="1jfbzx9wiwmta">
              Arrête d&apos;offrir ton temps libre. Ta dévotion est déjà là. Ce qu&apos;il te faut maintenant, c&apos;est le bon
              outil.
            </p>
            <p className="text-xl mt-4 text-white" data-id="element-179" data-mp="qpmywwjtcmro">Planifie dès aujourd&apos;hui une année entière de cours d&apos;espagnol.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}